import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Membership } from '../../../../models/entities/membership';

export interface MemberSelectorDialogInput
{
    title: string;
    preselectedMemberIds: number[];
}

export interface MemberSelectorDialogOutput
{
    success: boolean;
    selectedMembers: Membership[];
}

@Component({
    selector: 'app-member-selector-dialog',
    templateUrl: './member-selector-dialog.component.html',
})
export class MemberSelectorDialogComponent implements OnInit
{
    selectedMembers: Membership[] = [];

    constructor(
            private _dialogRef: MatDialogRef<MemberSelectorDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public data: MemberSelectorDialogInput,
    ) {
    }

    ngOnInit(): void {
    }

    updateMembers(members: Membership[]) {
        this.selectedMembers = members;
    }

    closeAndConfirm() {
        this._dialogRef.close(<MemberSelectorDialogOutput>{
            success: true,
            selectedMembers: this.selectedMembers,
        });
    }

}
